import React, { Component } from 'react'


export default class EmptyItem extends Component {
  render = () => <div className={this.props.className || null} style={{ visibility: 'hidden' }} />
}
